

const criar = (vm) => {

    let doc = new vm.$JsPDF('l', 'pt');
    vm.entradas = vm.$utils.exportaPdf.trataEntrada(vm.entradas);
    vm.$utils.exportaPdf.adicionaLogos(doc, vm.nomeImagemParceiro)

    doc.setFontSize (14)
    doc.setFontType ("bold")
    doc.centerText ('Relatório (Comparativo Confinamento - Simulação Avançada)', 50)

    // estilos
    let estiloColuna = {
      halign: 'right',
      textColor: 0,
      columnWidth: parseInt(550 / (vm.lista.length)),
      fontSize: 10,
      font: "helvetica",
    }

    let numeroPagina = 0;

    let options = {
      theme: 'striped',
      styles: {
        overflow: 'linebreak'
      },
      startY: 85,
      margin: {top: 30},
      drawCell: function (row, data) {
      if (row.text.length && row.text[0].replace(/[^0-9-]/g, '')) {
        let isComparativo = false;
        data.row.raw.forEach(el => {
          if (el.includes('comparativo')) isComparativo = true;
        })
        const text = row.text[0].replace(/[^0-9-]/g, '');
        if (isComparativo && text !== '-') {
          text.includes('-') ? doc.setTextColor('#FF3348') : doc.setTextColor('#54B07D');
        }
      }
    },
      addPageContent: function (data) {
        doc.setFontSize(10);
        if (numeroPagina !== doc.internal.getNumberOfPages()) {
          numeroPagina = doc.internal.getNumberOfPages()
          doc.text(40, 570, String(numeroPagina))
          doc.text(660, 570, 'Powered by Rancho Soluções');
        }
      },
      headerStyles: {
        fillColor: 255,
        textColor: 0,
        halign: 'right'
      },
      columnStyles:{
        0: {
          columnWidth: 200,
          fontStyle: 'bold',
          fillColor: [25, 150, 190],
          lineColor: [25, 150, 190],
          textColor: 255,
          fontSize: 10,
          font: "helvetica",
        },
        1: estiloColuna,
        2: estiloColuna,
        3: estiloColuna,
        4: estiloColuna,
        5: estiloColuna
      }
    }

    // CONSOLIDANDO DADOS
    let dados = []
    vm.resultados.forEach((resultados, index) => {
      let dado = {
        resultados,
        entradas: vm.entradas[index]
      }
      dados.push(dado)
    });

    function _pegarDescricao (val) {
      return vm.pegarDescricao(val.split('.').pop())
    }

    let cfgCampos = {
      'quebraPesoOrigemBalancaoDestino': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida']
      },
      'quebraPesoOrigemBalancinhaDestino': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida']
      },
      'despesaGtaFunruralGadoEngordaTercerizadoCab': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida']
      },
      'despesaFreteCab': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida']
      },
      'resultados.economicos.analiseEconomica.principal.rentabilidadeOperacaoBoitel': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida']
      },
      'pesoEntradaBoitelArrobaProduzida': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'rendimentoDeEntradaBoitelViaArrobaProduzidaOpcional': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'precoArrobaProduzida': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'rendimentoDeEntradaEspecificoBoitelViaParceriaOpcional': {
        sistemasProducao: ['Parceria']
      },
      'resultados.produtivos.pesoEntradaKgBalancinhaDestino': {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.capitalInvestido': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoGado': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoGad': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoFinanceira': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.diferencaAplicacaoGadoFinanceira': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementado': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementadoComparativo': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementado': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementadoComparativo': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.indiceLucratividade': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaInternaRetornoTir': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorPresenteLiquidoVpl': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaMensalCapitalInvestidoGado': {
        sistemasProducao: ['Boitel - kg de alimento consumido', 'Boitel - diária']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.capitalInvestido': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoGado': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoFinanceira': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.diferencaAplicacaoGadoFinanceira': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementado': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementado': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.indiceLucratividade': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaInternaRetornoTir': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorPresenteLiquidoVpl': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaMensalCapitalInvestidoGado': {
        sistemasProducao: ['Confinamento próprio','Semiconfinamento ou Confinamento em pasto']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.capitalInvestido' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoGado' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoFinanceira' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.diferencaAplicacaoGadoFinanceira' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorPresenteLiquidoVpl' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaMensalCapitalInvestidoGado' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementado' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementadoComparativo': {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementado' : {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementadoComparativo': {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.indiceLucratividade ':{
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaInternaRetornoTir': {
        sistemasProducao: ['Parceria']
      },
      'pesoEntradaBoitelParceria': {
        sistemasProducao: ['Parceria']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.capitalInvestido': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoGado': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoFinanceira': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.diferencaAplicacaoGadoFinanceira': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorPresenteLiquidoVpl': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaMensalCapitalInvestidoGado': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementado': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementadoComparativo': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.indiceLucratividade': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaInternaRetornoTir': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.quantidadeArrobaProduzida': {
        sistemasProducao: ['Boitel - @ produzida']
      },
      'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.pontoEquilibrioArrobaProduzida': {
        sistemasProducao: ['Boitel - @ produzida']
      }
    }

    function _configCampo (campo, valor, indexEntrada) {
      if (!valor && valor !== '0') return 'Não Avaliado';
      let cfg = cfgCampos[campo]
      let campoTratado = ''
      if(campo.indexOf('.') >= 0) {
        campoTratado = campo.split('.').pop()
      } else {
        campoTratado = campo
      }
      if (!cfg) {
        for(let descricaoIndex in vm.descricoes.items){
          if(descricaoIndex == campoTratado) {
            if(vm.descricoes.items[descricaoIndex].prefixo != null) {
              valor = vm.descricoes.items[descricaoIndex].prefixo+" "+valor
            }
            if(vm.descricoes.items[descricaoIndex].sufixo != null) {
              valor += " "+vm.descricoes.items[descricaoIndex].sufixo
            }
            return valor
          }
        }
        return valor
      }
      let entrada = vm.entradas[indexEntrada]
      if(cfg.sistemasProducao && !vm.shouldShow(entrada, cfg.sistemasProducao)) return "Não Avaliado"
      for(let descricaoIndex in vm.descricoes.items){
        if(descricaoIndex == campoTratado) {
          if(vm.descricoes.items[descricaoIndex].prefixo != null) {
            valor = vm.descricoes.items[descricaoIndex].prefixo+" "+valor
          }
          if(vm.descricoes.items[descricaoIndex].sufixo != null) {
            valor += " "+vm.descricoes.items[descricaoIndex].sufixo
          }
          return valor
        }
      }
      return valor
    }
  const colunaNames = vm.entradas.map(el => el.nome);

    // INFORMACOES PRODUTIVAS
    let camposInformacoesProdutivas = ['nome', 'estagioNegocio', 'modalidadeDaVendaEscolhida','modalidadeDeSistemaDeProducaoEscolhida', 'racaDosAnimais','sexoDosAnimais','padraoRacialPredominante','totalAnimaisLote','pesoMedioEntradaKgCabBaseOrigem','quantidadeDiariasArracoamento','gmdKgD','gmdKgDComparativo','idadeEntradaMeses','mortalidadePercentual','consumoMateriaSecaPercPV','materiaSecaDietaPerc','quebraPesoOrigemBalancaoDestino','quebraPesoOrigemBalancinhaDestino', 'rendimentoDeCarcacaDaEntrada','rendimentoDeCarcacaDoAbate','pesoEntradaBoitelArrobaProduzida','rendimentoDeEntradaBoitelViaArrobaProduzidaOpcional','pesoEntradaBoitelParceria','rendimentoDeEntradaEspecificoBoitelViaParceriaOpcional','frigorificoDeAbate','estadoDeOrigem','cidadeDeOrigem']
    let informacoesProdutivas = vm.$utils.exportaPdf.geraTabela(vm.entradas, camposInformacoesProdutivas, vm.pegarDescricao, _configCampo, colunaNames)

    // INFORMACOES PRODUTIVAS
    let camposInfoProdutivas = ['valorDoGadoRCabeca', 'precoReferenciaDoBoiGordo', 'taxaRemuneracaoCapitalGado', 'dataPagamentoGado', 'dataD1Arracoamento', 'diasEntreOEmbarqueEoAbate', 'diasEntreAbateRecebimento', 'diasExtrasParaRecebimento', 'deducoesAplicadasSobreROB', 'depreciacaoRcab', 'amortizacaoRcab', 'naoOperacionalRcab', 'impostoDeRendaRcab', 'precoVendaBruto', 'diferencialDeBase', 'descontoAplicadoVendaVista', 'premioEuArroba', 'premioHiltonArroba', 'premioAngusArroba', 'premioAcabamentoArroba', 'outrosPremios', 'precoArrobaProduzida', 'custoOperacionalCabDia', 'custoNutricaoDiarioMedioCab', 'custoNutricaoDiarioMedioCabComparativo', 'custoProtocoloSanitarioSisbovCab', 'custoMedicamentoOutrosCab', 'despesaGtaFunruralGadoEngordaTercerizadoCab', 'despesaFreteCab', 'despesaComissaoCompraCab', 'despesaComercializacaoCab', 'despesaGtaAbateCab', 'despesaDeAbateAssessoriaOutrasDespesasCAB', 'despesaDeICMSCAB']
    let infoProdutivas = vm.$utils.exportaPdf.geraTabela(vm.entradas, camposInfoProdutivas, vm.pegarDescricao, _configCampo, colunaNames)

    // RESULTADOS PRODUTIVOS ECONOMICOS PRINCIPAIS
    let camposResultadoProdutivosEconomicosPrincipais = ['produtivos.pesoSaidaKgBaseOrigem','produtivos.ganhoDePesoKG','produtivos.quantidadeKGProduzidadaLote', 'produtivos.pesoSaidaArrobaBaseOrigem','produtivos.ganhoDePesoArroba' ,'principais.dataAbate', 'economicos.analiseEconomica.custoProducao.custoArrobaEntradaMagra', 'economicos.analiseEconomica.principal.rentabilidadeOperacao', 'principais.lucroLiquidoCab', 'principais.lucroLiquidoCabComparativo', 'economicos.analiseEconomica.geral.dataLiquidacaoFinanceira', 'economicos.analiseEconomica.custoProducao.custoArrobaVendida', 'economicos.analiseEconomica.custoProducao.custoPorArrobaProduzida', 'economicos.analiseEconomica.principal.precoArrobaVendidaLivre']
    let resultadoProdutivosEconomicosPrincipais = vm.$utils.exportaPdf.geraTabela(vm.resultados, camposResultadoProdutivosEconomicosPrincipais, _pegarDescricao, _configCampo, colunaNames)

    // RESULTADOS PRODUTIVOS
    let camposResultadosProdutivos = ['resultados.produtivos.pesoEntradaKgBalancaoDestino', 'resultados.produtivos.pesoEntradaKgBalancinhaDestino', 'resultados.produtivos.pesoEntradaKgBaseOrigem', 'resultados.produtivos.pesoEntradaArrobaBaseOrigem', 'resultados.produtivos.pesoSaidaKgBaseOrigem', 'resultados.produtivos.pesoSaidaArrobaBaseOrigem', 'resultados.produtivos.pesoSaidaKgCarcacaQuenteBaseOrigem', 'resultados.produtivos.quantidadeArrobaProduzidadaCabecaBaseOrigem', 'resultados.produtivos.quantidadeArrobaProduzidadaLoteBaseOrigem', 'resultados.produtivos.quantidadeArrobaAbatidasLoteBaseOrigem', 'resultados.produtivos.quantidadeContratosBmfProtecaoLote', 'entradas.dataD1Arracoamento', 'resultados.produtivos.dzArracoamento', 'resultados.produtivos.dataEmbarque', 'resultados.produtivos.dataAbate', 'resultados.produtivos.cicloProdutivoDias', 'resultados.produtivos.cicloProdutivoMeses', 'resultados.produtivos.gmdKgdBaseOrigem', 'resultados.produtivos.gmdKgdBaseOrigemComparativo', 'resultados.produtivos.gmdKgdBaseBalancaoDestino', 'resultados.produtivos.gmdKgdBaseBalancaoDestinoComparativo', 'resultados.produtivos.gmdKgdBaseBalancinhaDestino', 'resultados.produtivos.gmdKgdBaseBalancinhaDestinoComparativo', 'resultados.produtivos.ganhoCarcacaKgdBaseOrigem', 'resultados.produtivos.ganhoCarcacaKgdBaseBalancaoDestino', 'resultados.produtivos.ganhoCarcacaKgdBaseBalancinhaDestino', 'resultados.produtivos.rendimentoGanhoBaseOrigem', 'resultados.produtivos.rendimentoGanhoBaseBalancaoDestino', 'resultados.produtivos.rendimentoGanhoBaseBalancinhaDestino', 'resultados.produtivos.idadeAbateMeses', 'resultados.produtivos.diasParaGanhar1ArrobaBaseOrigem', 'resultados.produtivos.conversaoAlimentarKgMsKgPV', 'resultados.produtivos.eficienciaBiologicaKgMsArrobaProduziada', 'resultados.produtivos.eficienciaAlimentarKgPvKgMs', 'resultados.produtivos.pesoVivoMedioDuranteArracoamentoKg', 'resultados.produtivos.consumoMedioMateriaSecaDiarioKgCab', 'resultados.produtivos.consumoMedioMateriaOriginalDiarioKgCab', 'resultados.produtivos.mortesCabecas', 'resultados.produtivos.pesoVivoColocadoKgBaseOrigem']
    let resultadosProdutivos  = vm.$utils.exportaPdf.geraTabela(dados, camposResultadosProdutivos, _pegarDescricao, _configCampo, colunaNames)

    /* ================ RESULTADOS ECONOMICOS ==================== */

    // ANALISE ECONOMICA GERAL
    let camposAnaliseEconomicaGeral = ['resultados.economicos.analiseEconomica.geral.agioArrobaEntrada', 'resultados.economicos.analiseEconomica.geral.dataLiquidacaoFinanceira', 'resultados.economicos.analiseEconomica.geral.cicloFinanceiroMeses', 'resultados.economicos.analiseEconomica.geral.custeioCab', 'resultados.economicos.analiseEconomica.geral.custoToneladaMsTon']
    let analiseEconomicaGeral = vm.$utils.exportaPdf.geraTabela(dados, camposAnaliseEconomicaGeral, _pegarDescricao, _configCampo, colunaNames)

    // ANÁLISE DO CUSTO DE PRODUÇÃO
    let camposAnaliseCustoProducao = ['resultados.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzida', 'resultados.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzidaComparativo', 'resultados.economicos.analiseEconomica.custoProducao.outrosCustosPorArrobaProduzidada', 'resultados.economicos.analiseEconomica.custoProducao.despesasPorArrobaProduzida', 'resultados.economicos.analiseEconomica.custoProducao.custoPorArrobaProduzida', 'resultados.economicos.analiseEconomica.custoProducao.custoArrobaEntradaMagra', 'resultados.economicos.analiseEconomica.custoProducao.custoArrobaVendida', 'resultados.economicos.analiseEconomica.custoProducao.custoAnimalVendidoComImposto']
    let analiseCustoProducao = vm.$utils.exportaPdf.geraTabela(dados, camposAnaliseCustoProducao, _pegarDescricao, _configCampo, colunaNames)

    // ANÁLISE ECONÔMICA PRINCIPAL
    let camposAnaliseEconomicaPrincipal = ['resultados.economicos.analiseEconomica.principal.lucratividadeOperacao', 'resultados.economicos.analiseEconomica.principal.rentabilidadeOperacao', 'resultados.economicos.analiseEconomica.principal.rentabilidadeOperacaoBoitel', 'resultados.economicos.analiseEconomica.principal.taxaMinimaAtratividadeIouTMA', 'resultados.economicos.analiseEconomica.principal.margenEBITDA', 'resultados.economicos.analiseEconomica.principal.margemPorArrobaVendidaLivre', 'resultados.economicos.analiseEconomica.principal.precoArrobaVendidaLivre', 'resultados.economicos.analiseEconomica.principal.precoArrobaVendidaBruto']
    let analiseEconomicaPrincipal = vm.$utils.exportaPdf.geraTabela(dados, camposAnaliseEconomicaPrincipal, _pegarDescricao, _configCampo, colunaNames)

    // DRE DO ANIMAL SUPLEMENTADO, SEM CONSIDERAR MORTALIDADE
    let camposDreAnimalSuplementado = ['resultados.economicos.dre.receitaOperacionalBrutaRobCab', 'resultados.economicos.dre.deducoesCab', 'resultados.economicos.dre.receitaOperacionalLiquidaRolCab', 'resultados.economicos.dre.custoProdutoVendidoCpvCab', 'resultados.economicos.dre.lucroBrutoCab', 'resultados.economicos.dre.lucroBrutoCabComparativo', 'resultados.economicos.dre.despesaTotalCab', 'resultados.economicos.dre.ebitdaResultadoOperacionalCab', 'resultados.economicos.dre.depreciacaoCab', 'resultados.economicos.dre.amortizacaoCab', 'resultados.economicos.dre.ebitResultadoOperacionalCab', 'resultados.economicos.dre.financeiroCab', 'resultados.economicos.dre.naoOperacionalCab', 'resultados.economicos.dre.lucroAntesIrLairCab', 'resultados.economicos.dre.lucroAntesImpostoRendaComparativo', 'resultados.economicos.dre.valorIrCab', 'resultados.economicos.dre.lucroLiquidoCab', 'resultados.economicos.dre.lucroLiquidoCabComparativo']
    let dreAnimalSuplementado = vm.$utils.exportaPdf.geraTabela(dados, camposDreAnimalSuplementado, _pegarDescricao, _configCampo, colunaNames)

    // BREAKEVEN DO BOI MAGRO
    let camposBreakevenBoiMagro = ['resultados.economicos.breakeven.boiMagro.valorVendaArroba', 'resultados.economicos.breakeven.boiMagro.agioVendaArroba', 'resultados.economicos.breakeven.boiMagro.valorVendaBoi']
    let breakevenBoiMagro = vm.$utils.exportaPdf.geraTabela(dados, camposBreakevenBoiMagro, _pegarDescricao, _configCampo, colunaNames)

    // BREAKEVEN DO PREÇO DE VENDA
    let camposBreakevenPrecoVenda = ['resultados.economicos.breakeven.precoVenda.pontoEquilibrioArrobaVendidaBruto']
    let breakevenPrecoVenda = vm.$utils.exportaPdf.geraTabela(dados, camposBreakevenPrecoVenda, _pegarDescricao, _configCampo, colunaNames)

    // PONTO DE EQUILIBRIO
    let camposPontoDeEquilibrio = ['resultados.economicos.breakeven.precoVenda.pontoEquilibrioArrobaVendidaBruto', 'resultados.economicos.analiseEconomica.custoProducao.pontoEquilibrioDiariaCabDia', 'resultados.economicos.breakeven.boiMagro.valorVendaBoi', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.pontoEquilibrioArrobaProduzida', 'resultados.economicos.breakeven.boiMagro.valorVendaArroba', 'resultados.economicos.breakeven.boiMagro.agioVendaArroba']
    let pontoDeEquilibrio = vm.$utils.exportaPdf.geraTabela(dados, camposPontoDeEquilibrio, _pegarDescricao, _configCampo, colunaNames)

    // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO PRÓPRIO)
    let camposOticaDoInvestidorSistemaProprio = ['resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.capitalInvestido', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.diferencaAplicacaoGadoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.indiceLucratividade', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaInternaRetornoTir', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorPresenteLiquidoVpl', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaMensalCapitalInvestidoGado']
    let oticaDoInvestidorSistemaProprio = vm.$utils.exportaPdf.geraTabela(dados, camposOticaDoInvestidorSistemaProprio, _pegarDescricao, _configCampo, colunaNames)

    // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO TERCEIRIZADO - DIÁRIAS OU ALIMENTO CONSUMIDO)
    let camposOticaDoInvestidorSistemaTerceirizadoDiarias = ['resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.capitalInvestido', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.diferencaAplicacaoGadoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.indiceLucratividade', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaInternaRetornoTir', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorPresenteLiquidoVpl', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaMensalCapitalInvestidoGado']
    let oticaDoInvestidorSistemaTerceirizadoDiarias = vm.$utils.exportaPdf.geraTabela(dados, camposOticaDoInvestidorSistemaTerceirizadoDiarias, _pegarDescricao, _configCampo, colunaNames)

    // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO TERCEIRIZADO - MODELO DE ARROBA PRODUZIDA, CONSIDERANDO PERDAS COM MORTALIDADE)
    let camposOticaDoInvestidorTerceirizadoArrobaProduzida = ['resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.capitalInvestido', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.diferencaAplicacaoGadoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorPresenteLiquidoVpl', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaMensalCapitalInvestidoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.indiceLucratividade', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaInternaRetornoTir', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.quantidadeArrobaProduzida', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.pontoEquilibrioArrobaProduzida']
    let oticaDoInvestidorTerceirizadoArrobaProduzida = vm.$utils.exportaPdf.geraTabela(dados, camposOticaDoInvestidorTerceirizadoArrobaProduzida, _pegarDescricao, _configCampo, colunaNames)

    // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO TERCEIRIZADO - MODELO DE PARCERIA, CONSIDERANDO PERDAS COM MORTALIDADE)
    let camposOticaDoInvestidorTerceirizadoParceria = ['resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.capitalInvestido', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.diferencaAplicacaoGadoFinanceira', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorPresenteLiquidoVpl', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaMensalCapitalInvestidoGado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementado', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementadoComparativo', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.indiceLucratividade', 'resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaInternaRetornoTir']
    let oticaDoInvestidorTerceirizadoParceria = vm.$utils.exportaPdf.geraTabela(dados, camposOticaDoInvestidorTerceirizadoParceria, _pegarDescricao, _configCampo, colunaNames)

    addTab (doc, 'Informações Produtivas', 125, informacoesProdutivas, options, true)
    addTab (doc, 'Informações Financeiras', 0, infoProdutivas, options)
    addTab (doc, 'Resultados Principais', 0, resultadoProdutivosEconomicosPrincipais, options)
    addTab (doc, 'Resultados Produtivos', 0, resultadosProdutivos, options)
    addTab (doc, 'Resultados Econômicos - Análise econômica geral', 0, analiseEconomicaGeral, options)
    addTab (doc, 'Resultados Econômicos - Análise do custo de produção', 0, analiseCustoProducao, options)
    addTab (doc, 'Resultados Econômicos - Análise econômica principal', 0, analiseEconomicaPrincipal, options)
    addTab (doc, 'DRE do animal suplementado, sem considerar mortalidade', 0, dreAnimalSuplementado, options)
    addTab (doc, 'Pontos de Equilíbrio', 0, pontoDeEquilibrio, options)

    doc.addPage()
    doc.setFontSize (14)
    doc.setFontType ("bold")
    doc.centerText ('Análise de viabilidade do projeto, considerando as perdas com mortalidade',  40);

    addTab (doc, 'Ótica do investidor', 40, oticaDoInvestidorSistemaProprio, options, true)
    doc.setFontSize (11)
    doc.centerText ('(sistema de arraçoamento próprio)',  95)

    if(oticaDoInvestidorSistemaTerceirizadoDiarias.linhas.length){
      addTab (doc, 'Ótica do investidor', 0, oticaDoInvestidorSistemaTerceirizadoDiarias, options)
      doc.setFontSize (11)
      doc.centerText ('(sistema de arraçoamento terceirizado - diárias ou alimento consumido)',  55)
    }
    if(oticaDoInvestidorTerceirizadoArrobaProduzida.linhas.length){
      addTab (doc, 'Ótica do investidor', 0, oticaDoInvestidorTerceirizadoArrobaProduzida, options)
      doc.setFontSize (11)
      doc.centerText ('(sistema de arraçoamento terceirizado - modelo de arroba produzida,considerando perdas com mortalidade)',  55)
    }

    addTab (doc, 'Ótica do investidor', 0, oticaDoInvestidorTerceirizadoParceria, options)
    doc.setFontSize (11)
    doc.centerText ('(sistema de arraçoamento terceirizado - modelo de parceria, considerando perdas com mortalidade)',  55)

    //doc.save('comparativo_confinamento_avancado.pdf')

    return doc

}

const addTab = (doc, titulo, py, tabela, options, mesmaPagina) => {
  if (!mesmaPagina) doc.addPage()
  let tabPy = 40 + py
  doc.setFontSize (14)
  doc.setFontType ("bold")
  doc.centerText(titulo, tabPy);
  doc.setFontType ("normal")
  doc.setFontSize (9)
  doc.setTextColor(230,230,231)
  doc.centerText ('_________________________________________________', tabPy + 5);
  options.startY = tabPy + 25;
  doc.autoTable(tabela.colunas, tabela.linhas, options);
}


export default {
  criar
}




// WEBPACK FOOTER //
// ./src/services/relatorio/comparativo/confinamento/avancado.js